const SERVICES = [
  {
    icon: "ri-search-eye-line",
    title: "不良現象の原因究明",
    desc: "現象の観察、データ整理、仮説設定、検証を重ねながら、発生している不良の原因を論理的に絞り込みます。表面的な対処ではなく、再発防止につながる原因の把握を目指します。",
  },
  {
    icon: "ri-draft-line",
    title: "改善策の設計",
    desc: "原因に対して、材料・工程・条件・治工具・作業方法などの観点から改善策を設計します。実際の現場で実行可能な形まで落とし込みます。",
  },
  {
    icon: "ri-flask-line",
    title: "評価・検証方法の整理",
    desc: "改善前後の状態を正しく比較できるよう、評価項目・測定方法・判定基準を整理します。「何をもって改善とするか」を事前に明確にします。",
  },
  {
    icon: "ri-tools-line",
    title: "治工具・作業方法の改善提案",
    desc: "必要に応じて、治工具の見直しや作業手順の再設計を提案します。治工具の製作費や設備費はお客様負担とします。",
  },
];

export default function Services() {
  return (
    <section id="service" className="w-full py-24 md:py-32 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-6 md:px-10">
        <div className="mb-14 md:mb-20">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[1px] bg-primary-500" />
            <span className="text-[11px] tracking-[0.35em] text-primary-500 uppercase">Services</span>
          </div>
          <h4 className="font-heading text-3xl md:text-4xl text-foreground-900 leading-snug mb-6">
            <a href="#service" className="cursor-pointer">サービス内容</a>
          </h4>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl">
            原因究明研究所では、単発の分析で終わらせず、
            原因の特定から改善案の設計、評価方法の整理まで一貫して支援します。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {SERVICES.map((s, i) => (
            <div
              key={s.title}
              className="group relative bg-background-100 border border-background-200 rounded-lg p-8 md:p-10 hover:border-primary-300 transition-colors"
            >
              <div className="absolute top-6 right-6 text-[11px] tracking-[0.2em] text-secondary-400">
                0{i + 1}
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50 mb-6">
                <i className={`${s.icon} text-xl`}></i>
              </div>
              <h5 className="font-heading text-xl text-foreground-900 mb-3">{s.title}</h5>
              <p className="text-sm md:text-[15px] text-foreground-600 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}